export const HINT_ASK_ACCESS_GEOLOCATION = 'Please let us access your browsers geolocation in order to show you the closest places to your location.'
export const HINT_ABOUT_SECTION = 'Find a Big O Tires Location Near You'
